import React, {useEffect, useState} from "react";
import {Alert, Button, Col, Form, Modal, Row} from "react-bootstrap";
import {savePackage} from "../../../Api/Members/PackagesFetch";
import {emptyError, handleErrors} from "../../Errors";

const ModalPackage = ({show, handleClose, id, packageToEdit, isRenewal, onSaveSuccess, setMessage, setIsLoading}) => {
    const [errors, setErrors] = useState()
    const [generalError, setGeneralError] = useState()

    useEffect(() => {
        if (errors !== undefined && typeof errors === 'object' && !Array.isArray(errors)) {
            handleErrors(errors)
        }
    }, [errors])

    useEffect(() => {
        if (!show) setGeneralError(null)
    }, [show])

    const handleSubmit = (e) => {
        e.preventDefault()
        emptyError()
        setGeneralError(null)
        const emptyfields = document.querySelector('span.error_empty_field')
        if (!emptyfields) {
            const packageData = {
                total_credits: document.getElementById('pkg_total_credits').value,
                valid_from: document.getElementById('pkg_valid_from').value,
                valid_to: document.getElementById('pkg_valid_to').value,
            }
            if (!isRenewal && packageToEdit?.id) {
                packageData.id = packageToEdit.id
            }
            savePackage({id, packageData, setIsLoading, setErrors, setGeneralError, setMessage, onSaveSuccess, setShow: handleClose})
        }
    }

    const canEditDates = isRenewal || packageToEdit?.can_edit_dates !== false

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{isRenewal ? 'Rinnova Pacchetto' : 'Modifica Pacchetto'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {generalError && (
                    <Alert variant={'danger'} dismissible onClose={() => setGeneralError(null)}>
                        {generalError}
                    </Alert>
                )}
                <Form id={'packageForm'}>
                    <Row>
                        <Col md={12} className={'text-start position-relative mb-3'}>
                            <Form.Label className={'text-start'}>Crediti Totali</Form.Label>
                            <Form.Control
                                id={'pkg_total_credits'}
                                className={'form-control-sm'}
                                type={'number'}
                                name={'total_credits'}
                                min={1}
                                defaultValue={!isRenewal ? packageToEdit?.total_credits : ''}
                                required
                            />
                        </Col>
                        <Col md={6} className={'text-start position-relative mb-3'}>
                            <Form.Label className={'text-start'}>Data Inizio</Form.Label>
                            <Form.Control
                                id={'pkg_valid_from'}
                                className={'form-control-sm'}
                                type={'date'}
                                name={'valid_from'}
                                defaultValue={!isRenewal ? packageToEdit?.valid_from : ''}
                                disabled={!canEditDates}
                                required
                            />
                        </Col>
                        <Col md={6} className={'text-start position-relative mb-3'}>
                            <Form.Label className={'text-start'}>Data Fine</Form.Label>
                            <Form.Control
                                id={'pkg_valid_to'}
                                className={'form-control-sm'}
                                type={'date'}
                                name={'valid_to'}
                                defaultValue={!isRenewal ? packageToEdit?.valid_to : ''}
                                disabled={!canEditDates}
                                required
                            />
                        </Col>
                        {!canEditDates && (
                            <Col md={12}>
                                <small className={'text-muted'}>
                                    Le date non sono modificabili: il pacchetto è già iniziato o ha prenotazioni associate.
                                </small>
                            </Col>
                        )}
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className={'bg-danger border-0'} onClick={handleClose}>Annulla</Button>
                <Button className={'bkg-second border-0'} onClick={handleSubmit}>
                    {isRenewal ? 'Crea Pacchetto' : 'Salva Modifiche'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalPackage
